import React, { useEffect, useState } from "react";
import { Persona, Tooltip, mergeClasses } from "@fluentui/react-components";
import { List, ListItem } from '@fluentui/react-list-preview';
import { FluentSearch } from "../FluentUI/Fluent-Search";
import { FluentCheckbox } from "../FluentUI/Fluent-Checkbox";
import { FluentField } from "../FluentUI/Fluent-Field";
import { FluentDropdown } from "../FluentUI/Fluent-Dropdown";
import { useStyles } from "./select-styles";
import PropTypes from "prop-types";
import { highlightMatch } from "../../pages/new-dashboard/dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";
import { unavailableReason } from "../TaskAssignMember/TaskAssignMemberHelper";

const SelectMemberProject = ({
  selectedOwner,
  data,
  saveMembers,
  saveOwner,
  user,
  isEdit,
  noOwnerDropDown = false,
  labels,
  disabled = false
}) => {
  const [userData, setUserData] = useState(data?.allUsers);
  const [sortedUserData, setSortedUserData] = useState(data?.allUsers);
  const [userFilter, setUserFilter] = useState("");
  const [selectedMembers, setSelectedMembers] = useState(data?.Members);
  const [initialSelectedMembersId, setInitialSelectedMembersId] = useState([]);
  const classes = useStyles();
  useEffect(() => {
    let tempArray = [...userData || []];
  
    tempArray.sort((a, b) => {
      const isAUser = a.GroupId ? false : true;
      const isBUser = b.GroupId ? false : true;
  
      if (a.Id === selectedOwner?.Id) return -1;
      if (b.Id === selectedOwner?.Id) return 1;
  
      const isSelectedA = selectedMembers?.some(m => m.Id === a.Id && m.GroupId === a.GroupId);
      const isSelectedB = selectedMembers?.some(m => m.Id === b.Id && m.GroupId === b.GroupId);
  
      if (isSelectedA && !isSelectedB) return -1;
      if (!isSelectedA && isSelectedB) return 1;
  
      if (isSelectedA && isSelectedB) {
        if (isAUser && !isBUser) return -1;
        if (!isAUser && isBUser) return 1;
      }
  
      if (isAUser && !isBUser) return -1;
      if (!isAUser && isBUser) return 1;

      return a.Name.localeCompare(b.Name);
    });
  
    setSortedUserData(tempArray);
  }, [userData, selectedOwner, selectedMembers]);
  
  useEffect(() => {
    if (!data?.Members) return;

    let memberIds = data.Members
      .filter(member => !member.GroupId) 
      .map(member => member.UserId);

    let groupMemberIds = data.Members
      .filter(member => member.GroupId)
      .flatMap(group => group.Members)
      .map(member => member.UserId);

    let allMemberIds = [...new Set([...memberIds, ...groupMemberIds])];

    setInitialSelectedMembersId(allMemberIds);
  }, []);

  const selectAllTypes = (e, toggle) => {
    if (!initialSelectedMembersId.find(memberId => memberId === user?.userID)) return;
    if (toggle.checked) {
      setSelectedMembers(userData);
      saveMembers(userData);
    } else {
      let ownerUser;
      if(isEdit)
         ownerUser = userData.filter(member => member.Id === selectedOwner.Id);
      else
         ownerUser = userData.filter(member => member.Id === user?.userID);
      setSelectedMembers(ownerUser);
      saveMembers(ownerUser);
      if (selectedOwner.Id !== user?.userID && !isEdit) {
        saveOwner(ownerUser[0]?.Name);
      }
    }
  };

  const selectedMember = (e, selectedItems) => { //handles the selection and deselection of a member

    if (!initialSelectedMembersId.find(Id => Id === user?.userID) && isEdit) return;
    if (!noOwnerDropDown && !selectedItems.find(x => x.Id === selectedOwner.Id)) return;
 
    if(!selectedItems.find(x => x.Id === selectedOwner.Id)){
      saveOwner(selectedItems.find(x => x.Id === user?.userID)?.Name);
    }
    setSelectedMembers(selectedItems);
    saveMembers(selectedItems);
  };

  const getGroupMembers = (group) => {
    return group.Members.map((member) => (
      <div key={member.User.Id}>
        {member.User.Name} ({member.User.Role.Name})
      </div>
    ));
  };

  const filterSearchedMembers = () => { //filters allUsers based on the userFilter state provided by the search bar
    const selectAllListGroupsNew = userFilter?.toLowerCase() === "" ? (
      <div className={classes.selectAllContainer}>
        <FluentCheckbox
          onChange={selectAllTypes}
          label="Select All"
          required={false}
          componentStyle={classes.selectAllCheckbox}
          checked={selectedMembers?.length === userData?.length}
        />
      </div>
    ) : null;

    return (
      <>
        {selectAllListGroupsNew}
       
        <div>
          {
            sortedUserData?.filter(member => member.Name.toLowerCase().includes(userFilter.toLowerCase()) 
            || member.CompanyName?.toLowerCase().includes(userFilter.toLowerCase())
            || member.Role?.Name?.toLowerCase().includes(userFilter.toLowerCase())
            ).map((user) => {
            let fieldContent = user?.GroupId
              ? `${user?.Name}`
              : `${user?.Name}${user?.Role?.Name ? ` (${user.Role.Name})` : ""}`;

            // Archived/moved member (TAD-5898): tooltip carries the reason instead.
            let tooltipContent = user?.Archived
              ? unavailableReason(user)
              : user?.GroupId
                ? getGroupMembers(user)
                : `${fieldContent} - ${user?.CompanyName}`;
            return (
              <div key={`${user?.GroupId ? "group" : "user"}-${user?.Id}`}>
                <ListItem
                  className={classes.memberItem}
                  value={user}
                  navigationMode="items"
                  aria-label={user.Name}
                >
                  <Tooltip
                    content={tooltipContent}
                    id="tooltip-host"
                    positioning="above-start"

                  >
                    <Persona
                      name={user?.Name}
                      primaryText={highlightMatch(fieldContent, userFilter)}
                      secondaryText={highlightMatch(user?.CompanyName, userFilter)}
                      className={mergeClasses(
                        classes.profilePicture,
                        user?.Archived && classes.archivedMember,
                        user?.Archived && classes.archivedPersona
                      )}
                      avatar={{
                        color: user?.GroupId > 0 ?
                          "dark-green" :
                          selectedOwner?.Id === user?.Id ?
                            "brand" :
                            "platinum"
                      }}
                    ></Persona>

                  </Tooltip>
                </ListItem>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <div>
      <FluentField
      label={`${labels?.ProjectSingular ?? "Assign"} Members`}
        required={true}
        size={"small"}
      />
        <FluentSearch
          componentStyle={classes.searchPanel}
          size={"small"}
          placeholder={"Search members/groups"}
          onChange={(e) => {
            setUserFilter(e.target.value || "");
          }}
        />
        <div className={classes.memberListContainer} id="memberlistgroup">
          <List
            selectionMode="multiselect"
            selectedItems={selectedMembers}
            onSelectionChange={(e, data) => {
              selectedMember(e, data.selectedItems)
            }}
          >
            {filterSearchedMembers()}
          </List>
        </div>
      {(!noOwnerDropDown && (!isEdit || (isEdit && user?.userID === selectedOwner?.Id))) && <div id="ownerdropdown">
        <FluentField
          label="Owner"
          componentStyle={classes.projectOwnerEdit}
        >
          <FluentDropdown
            componentStyle={classes.ownerDropDown}
            value={selectedOwner?.Name}
            isControlled={true}
            selectedOptions={[selectedOwner?.Name]}
            options={selectedMembers?.filter(member => member.GroupId == null && !member.IsOrphaned).map(member => member.Name)}
            onChange={(e) => {
              saveOwner(e.target.outerText)
            }}
            disabled={disabled}
          />
        </FluentField>
      </div>}
    </div>
  );
};

SelectMemberProject.propTypes = {
  isEdit: PropTypes.bool,
  selectedOwner: PropTypes.shape({
    Id: PropTypes.number,
    Name: PropTypes.string
  }),
  user: PropTypes.shape({
    userID: PropTypes.number,
  }).isRequired,
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

export default SelectMemberProject;
